class BackInStock {
  constructor() {
    this.selectors = {
      notifyButton: '#notify_button',
      notifyButtonMobile: '#notify_button_mobile',
    };
    this.events = {
      backInStock: 'back-in-stock:change',
    };
    this.currentVariant = null;
    this.productId = window.productId && window.productId;
    this.screenMedia = window.matchMedia('(min-width: 749px)');
  }

  variantChange({ detail }) {
    this.currentVariant = detail;
  }

  notificationCallback({ status, errors, message }) {
    const messageWrap = (this.screenMedia.matches)
      ? document.querySelector('.message')
      : document.querySelector('.message-mobile');
    let elementMessage;

    if (status === 'OK') {
      elementMessage = `<p class="alert alert-success">${message && message}</p>`;
    } else {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const error in errors) {
        elementMessage = `<p class="alert alert-danger">${(errors[error].join())}</p>`;
      }
    }

    messageWrap.innerHTML += elementMessage;
  }

  backInStockCreate(event) {
    const { target } = event;

    if (target.matches(this.selectors.notifyButton)
    || target.matches(this.selectors.notifyButtonMobile)) {
      event.preventDefault();
      const email = (this.screenMedia.matches)
        ? document.querySelector('#notify_email').value
        : document.querySelector('#notify_email_mobile').value;
      const properties = {
        email,
        productId: this.productId,
        variantId: this.currentVariant.id,
        config: {
          accepts_marketing: true,
        },
      };

      window.BIS
        .create(properties.email, properties.variantId, properties.productId, properties.config)
        .then(this.notificationCallback.bind(this));
    }
  }

  initEventListeners() {
    document.addEventListener('click', this.backInStockCreate.bind(this));
    document.addEventListener(this.events.backInStock, this.variantChange.bind(this));
  }

  init() {
    this.initEventListeners();
  }
}

document.addEventListener('DOMContentLoaded', () => new BackInStock().init());
